import { render, staticRenderFns } from "./verifyEmail.vue?vue&type=template&id=50a4ec0d&"
import script from "./verifyEmail.vue?vue&type=script&lang=js&"
export * from "./verifyEmail.vue?vue&type=script&lang=js&"
import style0 from "./verifyEmail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports